import axios from 'axios'

export default () => {
  return axios.create({
    baseURL: process.env.NODE_ENV === 'production' ? `${window.location.origin}/api/` : `http://localhost:8081/api/`
  })
}
